import dayjs from 'dayjs';
import { $k18n } from '@/common/i18n';
export const ONE_DAY = 24 * 60 * 60 * 10000;
export const ONE_WEEK = 7 * ONE_DAY;
export const ONE_YEAR = 365 * ONE_DAY;
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

/**
 * .....多久之前
 * @returns 系统时间到之前指定时间的距离值
 * @param targetTime
 */
export const getTimeAgo = (targetTime: number) => {
    const now = dayjs();
    const time = dayjs(targetTime);
    const diffInMinutes = now.diff(time, 'minute');
    const diffInHours = now.diff(time, 'hour');

    if (diffInMinutes < 10) {
        return `${$k18n('Now')}`;
    } else if (diffInMinutes < 60) {
        return `${$k18n({
            text:
                diffInMinutes > 1 ? '{time} minutes ago' : '{time} minute ago',
            params: {
                time: diffInMinutes,
            },
        })}`;
    } else if (diffInHours < 24) {
        return `${$k18n({
            text: diffInHours > 1 ? '{time} hours ago' : '{time} hour ago',
            params: {
                time: diffInHours,
            },
        })}`;
    } else {
        return time.format('DD-MM-YYYY');
    }
};
